import React, {Component} from 'react';
import edapWrapper from '@homeaway/edap-wrapper';
import PropTypes from 'prop-types';
import {Button, ButtonPrimary} from '@homeaway/react-buttons/lib/transpiled/index';
import './ExpediaAuthComponent.less';
import authAccountTypes from '../../enums/AuthAccountTypes';
import umsSettings from '../../util/ums.settings';
import {apiPost} from '../../util/api.client';

const mpaasEnv = process.env.MPAAS_ENVIRONMENT;

class ExpediaAuthComponent extends Component {
    static get propTypes() {
        return {
            actionLocation: PropTypes.string,
            enableLoading: PropTypes.func,
            disableLoading: PropTypes.func
        };
    }

    static get defaultProps() {
        return {
            enableLoading: () => {},
            disableLoading: () => {}
        };
    }

    static getExpediaUrl() {
        let url = '';
        switch (mpaasEnv) {
            case 'production':
                url = 'https://www.expedia.com';
                break;
            case 'test':
            case 'stage':
            default:
                url = 'https://wwwexpediacom.trunk.sb.karmalab.net';
                break;
        }
        return url;
    }

    static getClientId() {
        let clientId = '';
        switch (mpaasEnv) {
            case 'production':
                clientId = '4F4EBDFEF9E04DDCD429EABC47FA4918';
                break;
            case 'test':
            case 'stage':
            default:
                clientId = '67DE0287BF47F004473658373E250308';
                break;
        }
        return clientId;
    }

    static getScreenWidth() {
        let screenWidth = screen.width;
        if (window.innerWidth) {
            screenWidth = window.innerWidth;
        } else if (document.documentElement.clientWidth) {
            screenWidth = document.documentElement.clientWidth;
        }
        return screenWidth;
    }

    static getScreenHeight() {
        let screenHeight = screen.height;
        if (window.innerHeight) {
            screenHeight = window.innerHeight;
        } else if (document.documentElement.clientHeight) {
            screenHeight = document.documentElement.clientHeight;
        }
        return screenHeight;
    }

    constructor(props) {
        super(props);
        // Window doesn't exist server side so this is needed, we need to pass a valid host name or component will not load in catalyst app!
        let hostPath = (typeof window !== 'undefined') ? window.location.origin : 'http://localhost:8080';
        let redirectUri = `${hostPath}/auth/ui/expediaLogin`;
        this.state = {
            expediaWindow: null,
            hostPath,
            redirectUri
        };
        this.onClickExpedia = this.onClickExpedia.bind(this);
        this.displayAppropriateButton = this.displayAppropriateButton.bind(this);
        this.loginAttempt = this.loginAttempt.bind(this);
        this.loginFailure = this.loginFailure.bind(this);
        this.loginSuccess = this.loginSuccess.bind(this);
        this.expediaSignInSignUp = this.expediaSignInSignUp.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
        this.register = this.register.bind(this);
        this.authenticate = this.authenticate.bind(this);
        this.expediaAccessToken = this.expediaAccessToken.bind(this);
        if (this.props.token) {
            this.register(this.props.token);
        }
    }

    componentDidMount() {
        window.addEventListener('successfulRedirect', this.handleResponse);
    }

    componentWillUnmount() {
        window.removeEventListener('successfulRedirect', this.handleResponse);
    }

    loginAttempt() {
        edapWrapper().push({
            name: 'login.attempt',
            data: {logintype: 'expedia', loginsource: 'lex', actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
    }

    loginSuccess(json) {
        this.setState({loggedIn: true});
        edapWrapper().push({
            name: 'login.success',
            data: {logintype: 'expedia', loginsource: 'lex', actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        this.props.setAuthJson(json);
        this.props.onClose();
    }

    loginFailure() {
        this.setState({loggedIn: false});
        edapWrapper().push({
            name: 'login.failure',
            data: {logintype: 'expedia', loginsource: 'lex', actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        this.props.handleError(this.props.lingua.read('error.generic'));
    }

    handleJson(json, accessToken) {
        if (json) {
            if (authAccountTypes.isNotUndefined(json.authType)) {
                let SIGNUP = this.checkAuthType(json.authType, authAccountTypes.SIGNUP);
                if (SIGNUP && umsSettings.isTCRequired(this.props.site)) {
                    // this is the SignUp scenario, so we need to update the pageName to TermsAndConditions only for the required EU brands
                    let pageName = 'TermsAndConditions';
                    this.props.performBulkPageUpdate(pageName, '', authAccountTypes.EXPEDIA, accessToken);
                    this.props.disableLoading();
                } else {
                    let umsOnly = this.checkAuthType(json.authType, authAccountTypes.UMS);
                    if (SIGNUP || umsOnly) {
                        this.register(accessToken);
                    } else {
                        this.authenticate(accessToken);
                    }
                }
            }
        }
    }

    checkAuthType(accountType, loginType) {
        return accountType.some((t) => (t === loginType));
    }

    expediaAuthStatus(accessToken) {
        const payload = {
            accessToken,
            authType: 'EXPEDIA'
        };

        return new Promise((resolve, reject) => {
            apiPost('/auth/aam/v3/token/status', payload).then((response) => {
                if (response.status >= 200 && response.status < 400) {
                    response.json().then((json) => {
                        this.handleJson(json, accessToken);
                        return resolve();
                    });
                }
            }).catch((e) => {
                // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                    this.loginFailure();
                }
                return reject(e);
            });
        });
    }

    expediaAccessToken(code) {
        const payload = {
            authCode: `${this.state.redirectUri};${code}`
        };

        return new Promise((resolve, reject) => {
            apiPost('/auth/aam/v3/expedia/token', payload).then((response) => {
                if (response.status >= 200 && response.status < 400) {
                    response.json().then((json) => {
                        this.expediaAuthStatus(json.accessToken);
                        return resolve('expedia access token resolved');
                    });
                }
            }).catch((e) => {
                // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                    this.loginFailure();
                }
                return reject(e);
            });
        });
    }

    register(token) {
        const payload = {
            userName: '',
            secret: token,
            authType: 'EXPEDIA',
            rememberMe: true
        };
        return new Promise((resolve, reject) => {
            apiPost('/auth/aam/v3/register', payload).then((response) => {
                this.checkStatus(response, resolve, reject);
            }).catch((e) => {
                return this.failLogin(e, reject);
            });
        });
    }

    authenticate(token) {
        const payload = {
            'userName': '',
            'authType': 'EXPEDIA',
            'secret': token,
            'rememberMe': true
        };

        return new Promise((resolve, reject) => {
            apiPost('/auth/aam/v3/authenticate', payload).then((response) => {
                this.checkStatus(response, resolve, reject);
            }).catch((e) => {
                this.failLogin(e, reject);
            });
        });
    }

    failLogin(e, reject) {
        this.props.disableLoading();
        this.loginFailure();
        return reject(e);
    }

    checkStatus(response, resolve, reject) {
        if (response.status >= 200 && response.status < 400) {
            response.json().then((json) => {
                this.loginSuccess(json);
            });
            return resolve();
        }
        this.props.disableLoading();
        this.loginFailure();
        return reject();
    }

    onClickExpedia() {
        this.loginAttempt();
        this.expediaSignInSignUp();
    }

    expediaSignInSignUp() {
        let expediaAuthWindow = this.openNewSocialAuthWindow(425, 450);
        this.setState({expediaWindow: expediaAuthWindow});
    }

    handleResponse() {
        let code = this.getExpediaCode();
        if (code !== '') {
            this.expediaAccessToken(code);
        } else {
            this.loginFailure();
        }
    }

    getExpediaCode() {
        let regex = new RegExp('code=([^&#]*)', 'i');
        let params = regex.exec(this.state.expediaWindow.location.search.substring(1));
        return params ? params[1] : '';
    }

    openNewSocialAuthWindow(width, height) {
        let dualScreenLeft = window.screenLeft !== 'undefined' ? window.screenLeft : screen.left;
        let dualScreenTop = window.screenTop !== 'undefined' ? window.screenTop : screen.top;
        let screenWidth = ExpediaAuthComponent.getScreenWidth();
        let screenHeight = ExpediaAuthComponent.getScreenHeight();
        let left = ((screenWidth / 2) - (width / 2)) + dualScreenLeft;
        let top = ((screenHeight / 2) - (height / 2)) + dualScreenTop;

        return window.open(
            `${ExpediaAuthComponent.getExpediaUrl()}/oauth/authorize?client_id=${ExpediaAuthComponent.getClientId()}&response_type=code&redirect_uri=${this.state.redirectUri}`,
            '', `channelmode=yes,width=${ width },height=${ height },top=${ top }, left=${ left}`, 'resizable=no,toolbar=no,menubar=no,location=no,status=no');
    }

    displayAppropriateButton() {
        if (typeof this.props.authStatus !== 'undefined') {
            return (
                <div className="SocialButtons__icon">
                    <ButtonPrimary label="" block className="btn--expedia btn-block" onClick={this.onClickExpedia}>
                        <span className="Expedia_icon SVGIcon--24px SVGIcon--inline-flex btn--spacing">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="34" viewBox="0 0 22 34" preserveAspectRatio="xMaxYMax meet">
                            <g fill="none" fillRule="evenodd">
                              <path fill="#EDB32A" d="M14.217 19.438l7.18-12.175c-.118-.336-.25-.666-.4-.99L8.285.905.151 12.55c.03.188.062.377.1.564l13.966 6.324"/>
                              <path fill="#212D4C"
                                  d="M12.847 8.452L12.405 7.2 8.653 2.175l.674-.168 6.47 5.602 3.806-1.091c.447-.115.954-.14 1.342-.137A10.962 10.962 0 0 0 14.67.64C8.954-1.4 2.67 1.592.638 7.32a10.994 10.994 0 0 0-.514 5.338l9.12-3.174 3.603-1.032M21.378 7.459c-.336.213-.826.5-1.315.654l-3.82 1.082-2.55 8.127-.661.215.539-6.208-.302-1.288-3.58 1.015-9.463 2.212a10.947 10.947 0 0 0 7.086 8.096c5.724 2.025 12.012-.946 14.05-6.628.876-2.448.82-5.002.016-7.277"
                              />
                            </g>
                        </svg>
                        </span>
                        <span className="Expedia_button_label">{this.props.lingua.read('lex.social.login.with.card.message.expedia')}</span>
                    </ButtonPrimary>
                </div>
            );
        }
        if (this.props.expediaIconDisplayed === true) {
            return (
                <div className="SocialButtons_icon">
                    <div className="small">
                        <Button type="button" className="btn btn-icon btn-default btn-icon-circle" onClick={this.onClickExpedia} label="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="34" viewBox="0 0 22 34" preserveAspectRatio="xMaxYMax meet">
                                <g fill="none" fillRule="evenodd">
                                    <path fill="#EDB32A"
                                        d="M14.217 19.438l7.18-12.175c-.118-.336-.25-.666-.4-.99L8.285.905.151 12.55c.03.188.062.377.1.564l13.966 6.324"
                                    />
                                    <path fill="#212D4C"
                                        d="M12.847 8.452L12.405 7.2 8.653 2.175l.674-.168 6.47 5.602 3.806-1.091c.447-.115.954-.14 1.342-.137A10.962 10.962 0 0 0 14.67.64C8.954-1.4 2.67 1.592.638 7.32a10.994 10.994 0 0 0-.514 5.338l9.12-3.174 3.603-1.032M21.378 7.459c-.336.213-.826.5-1.315.654l-3.82 1.082-2.55 8.127-.661.215.539-6.208-.302-1.288-3.58 1.015-9.463 2.212a10.947 10.947 0 0 0 7.086 8.096c5.724 2.025 12.012-.946 14.05-6.628.876-2.448.82-5.002.016-7.277"
                                    />
                                </g>
                            </svg>
                            <span className="sr-only">{'Expedia'}</span>
                        </Button>
                        <div className="Expedia_label">
                            <label>{this.props.lingua.read('lex.expedia.icon.label')}</label>
                        </div>
                    </div>
                </div>
            );
        }
        return (<div/>);
    }

    render() {
        return (
            <div>
                {this.displayAppropriateButton()}
            </div>
        );
    }
}

export default ExpediaAuthComponent;
